import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import OpsManagerDashboardComponent from './opsManagerDashboard.component';
import { getOpsManagerDashboard } from './opsManagerDashboard.actions';
import { getClients } from 'modules/clients/clients.actions';
import { getInternalUsers } from 'modules/common/common.actions';
import { setPageTitle, showToast } from 'modules/layout/layout.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { GET_INTERNAL_USERS_SUCCESS } from 'modules/common/store/types';

const mapStateToProps = (state) => ({
  overdueTasks: state.opsManagerDashboard.overdueTasks || [],
  coveragePeriods: state.opsManagerDashboard.coveragePeriods || [],
  activeFiles: state.opsManagerDashboard.activeFiles || [],
  closedFiles: state.opsManagerDashboard.closedFiles || [],
  clients: state.clients?.unmappedClients || [],
  isLoadingDashboard: state.opsManagerDashboard.isLoadingDashboard || false,
  isLoadingClients: state.clients?.isLoading || false,
});

const actionCreators = {
  getOpsManagerDashboard,
  getInternalUsers,
  getClients,
  setPageTitle,
  showToast,
};

const OpsManagerDashboardContainer = (props) => {
  const { getInternalUsers, getClients, getOpsManagerDashboard, showToast } = props;
  const [teamMembers, setTeamMembers] = useState([]);
  const [isLoadingTeamMembers, setIsLoadingTeamMembers] = useState(false);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setIsLoadingTeamMembers(true);
        const usersResult = await getInternalUsers();
        if (usersResult.type === GET_INTERNAL_USERS_SUCCESS) {
          const reloCounselorTypeId = '86EDC5F8-3E50-421F-8B38-49FB77A38290';
          const reloCounselors = (usersResult.response || []).filter(
            user => user.internalUserTypeId?.toUpperCase() === reloCounselorTypeId
          );
          setTeamMembers(reloCounselors);
        }
        setIsLoadingTeamMembers(false);
        await getClients();
      } catch {
        setIsLoadingTeamMembers(false);
        showToast('Failed to load initial data. Please refresh the page.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      }
    };
    props.setPageTitle('Ops Manager Dashboard');
    loadInitialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (teamMembers.length === 0) return;
    const userIds = teamMembers.map(u => u.internalUserId);
    getOpsManagerDashboard({ selectedUserIds: userIds, clientId: null, isVIP: null });
  }, [teamMembers, getOpsManagerDashboard]);

  return <OpsManagerDashboardComponent {...props} teamMembers={teamMembers} isLoadingTeamMembers={isLoadingTeamMembers} />;
};

export default connect(mapStateToProps, actionCreators)(OpsManagerDashboardContainer);
